module.exports = __webpack_public_path__ + "img/problem-phone-icon.94f09a97.png";